import {RouteRecordRaw} from "vue-router";
import Lista from "../pages/libros/Libros.vue";
import FormularioLibros from "../pages/libros/FormularioLibros.vue";

export const Libros: RouteRecordRaw[] = [
    {name: 'libros', path: '/libros', meta: {title: 'Libros'}, component: Lista},
    {name: 'libros.nuevo', path: '/libros/nuevo', meta: {title: 'Nuevo libro'}, component: FormularioLibros},
    {name: 'libros.editar', path: '/libros/:id', meta: {title: 'Editar libro'}, component: FormularioLibros},
];